<template>
  <div>
    <ApolloQuery
      :query="require('../graphql/FotoMedicao.gql')"
      :clientId="client"
      :variables="{ entidade, id, name, url, diario }"
      :update="data => {
        return data.fotoMedicao
      }"
      :debounce="500"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading">Carregando Foto...</div>

        <!-- Error -->
        <div v-else-if="error">{{ error.message }}</div>

        <!-- Result -->
        <div v-else-if="data" class="image">
          <figure>
            <img :src="(url ? '' : 'data:image/png;base64, ') + data" :alt="descricao" />
            <figcaption>{{ descricao }}</figcaption>
          </figure>
        </div>

        <!-- No result -->
        <div v-else class="alert alert-warning">Carregando Foto...</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    id: {
      default: 0,
      type: Number      
    },
    entidade: {
      default: 131,
      type: Number
    },
    name: {
      default: '',
      type: String
    },
    descricao: {
      default: '',
      type: String
    },
    url: {
      default: true,
      type: Boolean
    },
    all: {
      default: false,
      type: Boolean
    },
    diario: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    client() {
      return this.all ? 'v2' : 'v1'
    }
  }
};
</script>